export function nonNullable(value) {
  return value !== null && value !== void 0;
}
